import Reveal from "@/components/site/Reveal";
import { Icon } from "@/components/site/Icon";
import { RECRUITMENT_SERVICES, WHATSAPP_LINK } from "@/data/content";
import { FaArrowRight, FaCheck } from "react-icons/fa6";

const Services = () => {
  const scrollToContact = () => {
    if (window.lenis) {
      window.lenis.scrollTo("#contact", { duration: 1.0 });
    } else {
      document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-10">
        <Reveal className="mb-14 max-w-3xl">
          <p className="mb-4 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-gold-primary">
            <span className="h-px w-8 bg-gold-primary" /> Specialized Recruitment Services
          </p>
          <h2 className="font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-green-primary md:text-6xl">
            Comprehensive hiring solutions tailored for <span className="italic text-gradient-gold">growth & leadership.</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-green-primary md:text-lg font-medium">
            Whether you require strategic leadership hiring, large-scale staffing,
            or specialized IT & healthcare recruitment, PLACE8 delivers pre-screened talent across India.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-2">
          {RECRUITMENT_SERVICES.map((s, idx) => (
            <Reveal
              key={s.title}
              delay={(idx % 2) * 0.1}
              className="group relative flex flex-col justify-between overflow-hidden rounded-[28px] p-8 md:p-10 transition-all duration-500 hover:-translate-y-1 bg-green-primary text-white shadow-luxe border border-gold-soft"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full blur-3xl bg-gold-soft/20" />

              <div>
                <div className="flex items-center justify-between gap-4">
                  <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl text-2xl transition-transform duration-500 group-hover:scale-110 bg-gold-primary text-white shadow-md">
                    <Icon name={s.icon} />
                  </span>
                  <span className="rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider bg-white/10 text-gold-soft border border-gold-soft/40">
                    0{idx + 1} / Service
                  </span>
                </div>

                <h3 className="mt-6 font-display text-2xl font-light tracking-tight md:text-3xl text-white">
                  {s.title}
                </h3>

                <p className="mt-3 text-sm leading-relaxed text-white/85 font-normal">
                  {s.desc}
                </p>

                {/* Sub-capabilities */}
                <div className="mt-6 space-y-2 border-t border-gold-soft/40 pt-4">
                  {s.details.map((detail, dIdx) => (
                    <div key={dIdx} className="flex items-center gap-2.5">
                      <FaCheck className="text-xs shrink-0 text-gold-primary" />
                      <span className="text-xs font-semibold text-white/90">
                        {detail}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-8 pt-4 flex items-center justify-between">
                <button
                  onClick={scrollToContact}
                  data-testid={`service-hire-btn-${idx}`}
                  className="group/btn inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors text-gold-primary hover:text-white"
                >
                  Hire for {s.title}
                  <FaArrowRight className="text-xs transition-transform duration-300 group-hover/btn:translate-x-1" />
                </button>

                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-wider transition-all duration-300 hover:scale-105 bg-gold-primary text-white hover:bg-gold-luxury"
                >
                  Consult
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
